<template>
  <v-dialog v-model="dialog" max-width="600">
    <template v-slot:activator="{ on, lmModal }">
      <v-btn
        x-large
        elevation="3"
        class="ma-2"
        color="primary"
        v-bind="lmModal"
        v-on="on"
        >Click Me</v-btn
      >
    </template>
    <v-card elevation="3" class="modal-card">
      <v-card-title>
        <h3>Project Overview</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <hr />
      </v-card-title>
      <div class="modal-img">
        <iframe
          src="https://www.youtube.com/embed/gYM5AScglZs"
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen
          class="iframe-video"
        ></iframe>
      </div>
      <div class="project-info">
        <h1>Lucky's Market: The Last Real Cowboy</h1>
        <p>Lucky's Market Commercial</p>
        <ul class="details">
          <li><label>Client:</label>Lucky's Market</li>
          <li><label>Category:</label>Video Production</li>
          <li><label>Role:</label>Key Grip</li>
          <li>
            <label>Project URL:</label
            ><a
              target="_blank"
              href="https://www.youtube.com/watch?time_continue=31&amp;v=gYM5AScglZs"
              ><v-icon>mdi-youtube</v-icon> View on YouTube</a
            >
          </li>
        </ul>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style lang="scss">
</style>